if (!window.__abarLeadTrackingInitialized) {
window.__abarLeadTrackingInitialized = true;
const trackingScript = document.querySelector('script[data-abar-lead-tracking]');
const newsletterFormIds = new Set(
  (trackingScript?.dataset.klaviyoNewsletterFormIds || '')
    .split(/[\s,]+/)
    .map((formId) => formId.trim())
    .filter(Boolean),
);
const debugEnabled = new URLSearchParams(window.location.search).get('abar_tracking_debug') === '1';
const contactPendingKey = 'abar_contact_form_pending';
const contactPendingLifetime = 30 * 60 * 1000;
const pendingEvents = [];
const newsletterSubmissions = new Map();
const maxPublishRetries = 120;
let publishRetry;
let publishRetries = 0;
let lastPhoneClick = { href: '', timestamp: 0 };
let lastChatInteraction = 0;
let lastChatOpen = 0;

function debug(eventName, params) {
  if (debugEnabled) console.info(`[ABAR tracking] ${eventName}`, params);
}

function flushEvents() {
  const publish = window.Shopify?.analytics?.publish;

  if (typeof publish !== 'function') {
    if (publishRetries >= maxPublishRetries) return;
    publishRetries += 1;
    window.clearTimeout(publishRetry);
    publishRetry = window.setTimeout(flushEvents, 500);
    return;
  }

  publishRetries = 0;
  while (pendingEvents.length) {
    const { eventName, params } = pendingEvents.shift();
    debug(eventName, params);
    Promise.resolve(publish.call(window.Shopify.analytics, eventName, params)).catch(() => {});
  }
}

function trackAbarEvent(eventName, params) {
  pendingEvents.push({ eventName, params });
  flushEvents();
}

function readContactPending() {
  try {
    const value = window.sessionStorage.getItem(contactPendingKey);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
}

function writeContactPending() {
  try {
    window.sessionStorage.setItem(contactPendingKey, JSON.stringify({ timestamp: Date.now() }));
  } catch {}
}

function clearContactPending() {
  try {
    window.sessionStorage.removeItem(contactPendingKey);
  } catch {}
}

function trackSuccessfulContactForm() {
  const successMessage = document.querySelector(
    '[data-abar-contact-form="true"] .abar-contact-form__success[data-abar-contact-success="true"]',
  );
  const pending = readContactPending();

  if (!successMessage || !pending?.timestamp) return;

  clearContactPending();

  if (Date.now() - pending.timestamp > contactPendingLifetime) return;

  trackAbarEvent('contact_form_submit', {
    lead_type: 'contact_form',
    page_location: window.location.href,
  });
}

document.addEventListener(
  'submit',
  (event) => {
    if (!(event.target instanceof HTMLFormElement)) return;
    if (!event.target.closest('[data-abar-contact-form="true"]')) return;
    writeContactPending();
  },
  true,
);

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const eventPath = typeof event.composedPath === 'function' ? event.composedPath() : [];
  const isChatInteraction = eventPath.some(
    (element) => element instanceof Element && element.matches('shopify-chat, [data-abar-chat-trigger]'),
  );

  if (isChatInteraction) lastChatInteraction = Date.now();

  const phoneLink = event.target.closest('main[data-template="page.contact"] a[href^="tel:"]');
  if (!phoneLink) return;

  const timestamp = Date.now();
  const href = phoneLink.getAttribute('href') || '';

  if (lastPhoneClick.href === href && timestamp - lastPhoneClick.timestamp < 1500) return;

  lastPhoneClick = { href, timestamp };
  trackAbarEvent('phone_click', {
    lead_type: 'phone',
    page_location: window.location.href,
  });
});

function observeChatOpen() {
  const chatHost = document.querySelector('shopify-chat');
  if (!chatHost) return;

  const chatObserver = new MutationObserver((mutations) => {
    const opened = mutations.some(
      (mutation) => mutation.attributeName === 'open' && mutation.oldValue === null && chatHost.hasAttribute('open'),
    );

    if (!opened || !customElements.get('shopify-chat')) return;

    const timestamp = Date.now();
    if (timestamp - lastChatInteraction > 2000 || timestamp - lastChatOpen < 1500) return;

    lastChatOpen = timestamp;
    trackAbarEvent('chat_open', {
      lead_type: 'chat',
      provider: 'shopify_inbox',
      page_location: window.location.href,
    });
  });

  chatObserver.observe(chatHost, {
    attributes: true,
    attributeFilter: ['open'],
    attributeOldValue: true,
  });
}

window.addEventListener('klaviyoForms', (event) => {
  const detail = event.detail;
  const formId = typeof detail?.formId === 'string' ? detail.formId : '';

  if (detail?.type !== 'submit' || !newsletterFormIds.has(formId)) return;

  const timestamp = Date.now();
  const previousSubmission = newsletterSubmissions.get(formId) || 0;

  if (timestamp - previousSubmission < 1500) return;

  newsletterSubmissions.set(formId, timestamp);
  trackAbarEvent('newsletter_signup', {
    lead_type: 'newsletter',
    provider: 'klaviyo',
    form_id: formId,
    page_location: window.location.href,
  });
});

window.trackAbarEvent = trackAbarEvent;
observeChatOpen();
trackSuccessfulContactForm();
}
